import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { PeopleService } from '../people.service';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { TitleUrlsService } from '../../titles/title-urls.service';
import { InfiniteScroll } from '@common/core/ui/infinite-scroll/infinite.scroll';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl } from '@angular/forms';
var PeopleIndexComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PeopleIndexComponent, _super);
    function PeopleIndexComponent(people, urls, route, router) {
        var _this = _super.call(this) || this;
        _this.people = people;
        _this.urls = urls;
        _this.route = route;
        _this.router = router;
        _this.loading$ = new BehaviorSubject(false);
        _this.people$ = new BehaviorSubject(null);
        _this.sortFormControl = new FormControl('');
        _this.sortOptions = {
            'name': 'Name',
            'birth_date': 'Birthday',
            'popularity': 'Popularity',
            'created_at': 'Date Added',
        };
        return _this;
    }
    PeopleIndexComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.loadPeople();
        var defaultSort = this.route.snapshot.queryParams.sort ?
            this.route.snapshot.queryParams.sort :
            'popularity:desc';
        this.sortFormControl.setValue(defaultSort);
        this.sortFormControl.valueChanges.subscribe(function (sort) {
            _this.router.navigate([], { queryParams: { sort: sort } });
            _this.loadPeople(true);
        });
    };
    PeopleIndexComponent.prototype.loadPeople = function (reload) {
        var _this = this;
        if (reload === void 0) { reload = false; }
        this.loading$.next(true);
        var page = (this.people$.value && !reload) ? (this.people$.value.current_page + 1) : 1;
        this.people.getAll({ perPage: 10, page: page, mostPopular: true, order: this.sortFormControl.value })
            .pipe(finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function (response) {
            if (_this.people$.value && !reload) {
                response.pagination.data = _this.people$.value.data.concat(response.pagination.data);
            }
            _this.people$.next(response.pagination);
        });
    };
    PeopleIndexComponent.prototype.loadMoreItems = function () {
        this.loadPeople();
    };
    PeopleIndexComponent.prototype.canLoadMore = function () {
        return !this.isLoading() && this.people$.value.current_page < this.people$.value.last_page;
    };
    PeopleIndexComponent.prototype.isLoading = function () {
        return this.loading$.value;
    };
    return PeopleIndexComponent;
}(InfiniteScroll));
export { PeopleIndexComponent };
